import { useEffect } from 'react';

export const useDelay = (callback: () => void, delayTimeMS: number | undefined) => {
	useEffect(() => {
		let timer: ReturnType<typeof setTimeout>;

		if (delayTimeMS !== undefined) {
			timer = setTimeout(() => {
				callback();
			}, delayTimeMS);
		}

		return () => {
			timer && clearTimeout(timer);
		};
	}, [callback, delayTimeMS]);
};
